// extracted by mini-css-extract-plugin
module.exports = {"navigation":"VNavigation_navigation_2SRoy","list":"VNavigation_list_2OSDp","item":"VNavigation_item_1j5DY","link":"VNavigation_link_mj1aQ","line":"VNavigation_line_28xKr"};